import { defineStore } from 'pinia'

export interface MetaState {
  pageTitle: string
}

export const useMetaStore = defineStore('meta', {
  state: (): MetaState => ({
    pageTitle: 'Veraciti',
  }),

  actions: {
    updateTitle(title: string) {
      this.pageTitle = title
      // Update document title for browser tab
      if (typeof document !== 'undefined') {
        document.title = title
      }
    },
    // Alias for updateTitle
    setTitle(title: string) {
      this.updateTitle(title)
    },
  },
})
